function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_Dutch_Icons_5thWave_Finalisation"), /*#__PURE__*/React.createElement("path", {
  d: "M28.3 255.1v-21.2h14.2v-14.2H28.3v-21.3h14.2v-14.1H28.3V163h14.2v-14.2H28.3v-21.2h14.2V99.2H0v184.3h283.5v-28.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M195.6 193.3l-53.7 21.5-76.5-38.3L78 151.2l65.2 32.6 52.7-21.1 72.6 30.6-11 26.1z"
})));